import styled from 'styled-components';

import { mediaMin } from '../..';

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  gap: ${props => props.theme.space(2)};

  svg {
    width: auto !important;

    & > path {
      fill: transparent !important;
      stroke: ${props => props.theme.header.dropdown.icon};
    }
  }

  & > div {
    flex-grow: 1;
  }

  label {
    font-family: IntervalNextReg, sans-serif;
  }

  ${mediaMin.smallBreakpoint`
    padding-inline: ${props => props.theme.space(2)};
    width: 100%;

    label {
      margin-top: ${props => props.theme.space(1)};
    }

    svg {
      align-self: baseline;

      & > path {
        stroke: ${props => props.theme.header.mobile.dropdown.icon};
      }
    }
  `}
`;
